
import "./register.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";
import { useForm } from "react-hook-form";

/* navegação */
import { Link } from "react-router-dom";

/* banco de dados */
import { auth, db } from "../../services/firebaseConnection";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { collection, addDoc } from "firebase/firestore";

/* validação de campos */
import { masktelefone } from "../../services/masks/masks.ts";

/* funções auxiliares */
import { registerLog, checkExists, showError, formError, clearError, levelPassword, firstName } from "../../services/functions/functions.ts";

/* envio de email */
import { templateTokenEmail } from "../../services/emails/templates.js";

/* imagens */
import icon_success from "../../assets/sucesso.png";


export default function Register() {

    const [step, setStep] = useState(0);
    const [error, setError] = useState("0");
    const [levelPass, setLevelPass] = useState("");
    const [pnome, setPnome] = useState("");

    /* refs para tratamento de erros */
    const tokenRef = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

    const refEmpresa = useRef(null);
    const refLabelEmpresa = useRef(null);
    const refErrorEmpresa = useRef(null);

    const refResponsavel = useRef(null);
    const refLabelResponsavel = useRef(null);
    const refErrorResponsavel = useRef(null);

    const refEmail = useRef(null);
    const refLabelEmail = useRef(null);
    const refErrorEmail = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);

    const refErrorToken = useRef(null);

    const refSenha = useRef(null);
    const refLabelSenha = useRef(null);
    const refErrorSenha = useRef(null);

    const refConfSenha = useRef(null);
    const refLabelConfSenha = useRef(null);
    const refErrorConfSenha = useRef(null);

    const refError = useRef(null);
    const refErrorStep1 = useRef(null);
    const refErrorStep2 = useRef(null);
    /* -- */

    const { handleSubmit, register, getValues, setValue, watch } = useForm();

    /* mascaras para campos */
    const telefone = watch("telefone");
    /* -- */

    const [isPending, startTransition] = useTransition();

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {if (step === 2) { tokenRef[0].current?.focus(); }}, [step]);

    const [token, setToken] = useState("00000");
    const [counter, setCounter] = useState(1);

    useEffect(() => { const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000); return () => clearInterval(timer); }, [counter]);

    function formatMinutes(t) {

        var p1 = Math.trunc(t / 60);
        var p2 = t - (p1 * 60);

        p1 > -1 && p1 < 10 ? (p1 = '0' + p1.toString()) : p1 = p1.toString();
        p2 > -1 && p2 < 10 ? (p2 = '0' + p2.toString()) : p2 = p2.toString();

        return p1 + ':' + p2;
    }


    async function send_token(e) {

        e.preventDefault();

        if(counter > 0) {

            setError("token");
            refErrorToken.current.innerHTML = "Só é permitido o envio de novo token após o tempo do atual expirar.";
            refErrorToken.current.style.height = "1.5rem";
            return;

        } else {

            if(error === "token") {
                refErrorToken.current.innerHTML = "";
                refErrorToken.current.style.height = "0";
                for(let i = 1; i < 6; i++) { setValue("tk" + i, ""); }
            }
    
            const n = [4];
        
            n[0] = parseInt(Math.random() * 9);
            n[1] = parseInt(Math.random() * 9);
            n[2] = parseInt(Math.random() * 9);
            n[3] = parseInt(Math.random() * 9);
            n[4] = parseInt(Math.random() * 9);

            let tk = n[0].toString() + n[1].toString() + n[2].toString() + n[3].toString() + n[4].toString();
            setToken(tk);
            
            let nm = getValues("responsavel");
            let ma = getValues("email");
            let pnm = firstName(nm);
            setPnome(pnm);

            //envia email para o cliente
            const response = await fetch("https://google-services-712108985873.southamerica-east1.run.app/send-email", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                to: ma,
                subject: "Validar Email - Token de Cadastro",
                html: templateTokenEmail({nome: pnm, token: tk,}),
                }),
            });
            
            const data = await response.json();
            if(data.status !== "ok") {
                formError(refErrorStep2, JSON.stringify(data.message), true);
                return;
            }

            setCounter(299);

        }

    }



    async function register_step1(e) {

        e.preventDefault();

        formError(refErrorStep1, "", false);

        const v_nome = (nome) => { let validade = /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi; return validade.test(nome); }

        let ep = getValues("empresa");
        if(!v_nome(ep)) {
            showError(refEmpresa, refLabelEmpresa, refErrorEmpresa, "Esse nome de empresa não é valido, por favor verifique a digitação", setError, "empresa");
            return;
        }

        let nm = getValues("responsavel");
        if(!v_nome(nm)) {
            showError(refResponsavel, refLabelResponsavel, refErrorResponsavel, "Insira o nome completo do responsável (nome e sobrenome)", setError, "responsavel");
            return;
        }

        const v_email = (email) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(email); }

        let ma = getValues("email");
        if(!v_email(ma)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        let tl = getValues("telefone");
        if(tl.length < 15) {
            showError(refTelefone, refLabelTelefone, refErrorEmail, "Telefone inválido, digite o ddd + telefone", setError, "email");
            return;
        }
        
        startTransition( async() => {

            try {

                let ckma = await checkExists("clients", "email", ma);
                if(ckma !== 0) {
                    showError(refEmail, refLabelEmail, refErrorEmail, "Esse email já consta em nosso cadastro, tente resetar a senha", setError, "email");
                    return;
                }

                // cria o token e dispara o email
                const n = [4];
                
                n[0] = parseInt(Math.random() * 9);
                n[1] = parseInt(Math.random() * 9);
                n[2] = parseInt(Math.random() * 9);
                n[3] = parseInt(Math.random() * 9);
                n[4] = parseInt(Math.random() * 9);

                let tk = n[0].toString() + n[1].toString() + n[2].toString() + n[3].toString() + n[4].toString();
                setToken(tk);
                
                let pnm = firstName(nm);
                setPnome(pnm);

                //envia email para o cliente
                const response = await fetch("https://google-services-712108985873.southamerica-east1.run.app/send-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    to: ma,
                    subject: "Validar Email - Token de Cadastro",
                    html: templateTokenEmail({nome: pnm, token: tk,}),
                    }),
                });
                
                const data = await response.json();
                if(data.status !== "ok") {
                    formError(refErrorStep1, JSON.stringify(data.message), true);
                    return;
                }

                registerLog(-1, "/cadastro_step1/empresa=" + ep + ", responsavel=" + nm + ", email=" + ma + ", telefone=" + tl);

                setCounter(299);
                setStep(1);

            }
            catch(erro) {
                formError(refErrorStep1, JSON.stringify(erro), true);
            }

        })
        
    }



    function register_step2(e) {

        e.preventDefault();

        formError(refErrorStep2, "", false);

        let tk1 = getValues("tk1");
        let tk2 = getValues("tk2");
        let tk3 = getValues("tk3");
        let tk4 = getValues("tk4");
        let tk5 = getValues("tk5");
        
        let tk = tk1.toString() + tk2.toString() + tk3.toString() + tk4.toString() + tk5.toString();

        if(counter === 0) {
            setError("token");
            refErrorToken.current.innerHTML = "O tempo de validade do seu token expirou, clique em reenviar";
            refErrorToken.current.style.height = "1.5rem";
            return;
        }

        if(tk !== token) {
            setError("token");
            refErrorToken.current.innerHTML = "O token informado não está correto, verifique se é o último que você recebeu";
            refErrorToken.current.style.height = "1.5rem";
            for(let i = 1; i < 6; i ++) {
                tokenRef[i - 1].current.style.backgroundColor = "yellow";
            }
            return;
        }

        registerLog(-1, "/cadastro_step2/token=" + tk);

        setCounter(0);
        setStep(2);

    }



    async function cadastrar(data) {

        formError(refError, "", false);

        let sn = getValues("senha");
        if(sn.length < 6) {
            showError(refSenha, refLabelSenha, refErrorSenha, "A senha deve ter entre 6 a 12 caracteres", setError, "senha");
            return;
        }
        
        let cs = getValues("confsenha");
        if(sn !== cs) {
            showError(refConfSenha, refLabelConfSenha, refErrorConfSenha, "A confirmação da senha não está igual a senha", setError, "senha");
            return;
        }

        startTransition( async() => {

            try {

                const client = await createUserWithEmailAndPassword(auth, getValues("email"), sn);
                
                let uid = client.user.uid;

                let dt_atual = new Date();

                const clientdoc = await addDoc(collection(db, "clients"),
                { 
                    id: uid,
                    data_criacao: dt_atual,
                    empresa: getValues("empresa"),
                    responsavel: getValues("responsavel"),
                    email: getValues("email"),
                    telefone: getValues("telefone"),
                    data_inicio_vigencia: dt_atual,
                    data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
                })
                
                registerLog(uid, "/cadastro_step3/success");
                setStep(3);
                window.scrollTo(0, 0);

            }
            catch(erro) {
                formError(refError, JSON.stringify(erro), true);
            }
        
        })
    
    }


    function back_step() {
        setStep(0);
    }

 
    const handleChange = (e, index) => {
        if (e.target.value.length === 1 && tokenRef[index]?.current) {
            tokenRef[index].current.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && tokenRef[index]?.current) {
            tokenRef[index].current.focus();
        }
    };

    function clearErrorToken() {

        if(error === "token") {

            refErrorToken.current.innerHTML = "";
            refErrorToken.current.style.height = "0";

            for(let i = 1; i < 6; i ++) {
                tokenRef[i - 1].current.style.backgroundColor = "";
            }

            setError("0");
        }

    }



    return(
        <div className="context">
                    
            <Header access={0}></Header>
                    
            <div className="content">
                       
                { step === 0 && 
                (
                <>
                <div className="ft_topico">Faça seu cadastro com pouquíssimas informações</div>
                <div className="ft_descricao">Cadastrando-se, você terá acesso a nossa plataforma onde poderá realizar todas as configurações necessárias para seu agente funcionar de forma personalizada.</div>
                <div className="space"></div>
                <div className="border_form register_border_form">
                    <form className="form">
                        <span className="step_form">
                            <span className="step_form_number">Passo 1/3</span>
                            <span className="step_form_description">&nbsp;. Dados Cadastrais</span>
                        </span>
                        <span className="space_form"></span>

                        <span className="title_form">Cadastro</span>
                        <span className="subtitle_form">Preencha as informações da sua empresa para cadastrarmos seu contato.</span>
                        <span ref={refErrorEmpresa} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelEmpresa}>
                        <input type="text" placeholder="&nbsp;" maxLength={60} {...register("empresa")} ref={(el) => {refEmpresa.current = el; register("empresa").ref(el);}} onClick={() => clearError(refEmpresa, refLabelEmpresa, refErrorEmpresa, error, setError)} onChange={() => clearError(refEmpresa, refLabelEmpresa, refErrorEmpresa, error, setError)}></input>
                        <span className="label">Nome da Empresa</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <span ref={refErrorResponsavel} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelResponsavel}>
                        <input type="text" placeholder="&nbsp;" maxLength={60} {...register("responsavel")} ref={(el) => {refResponsavel.current = el; register("responsavel").ref(el);}} onClick={() => clearError(refResponsavel, refLabelResponsavel, refErrorResponsavel, error, setError)} onChange={() => clearError(refResponsavel, refLabelResponsavel, refErrorResponsavel, error, setError)}></input>
                        <span className="label">Nome do Responsável</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>
                        
                        <span ref={refErrorEmail} className="error_form"></span>
                        <div className="register_box">

                            <div className="register_box_email">
                                <label for="inp" className="inp" ref={refLabelEmail}>
                                <input type="text" placeholder="&nbsp;" maxLength={40} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                                <span className="label">Email</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="register_box_space"></div>

                            <div className="register_box_telefone">
                                <label for="inp" className="inp" ref={refLabelTelefone}>
                                <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone")} ref={(el) => {refTelefone.current = el; register("telefone").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorEmail, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorEmail, error, setError);}}}></input>
                                <span className="label">Telefone</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>
                        <span className="space_form"></span>
                        <span ref={refErrorStep1} className="error_form"></span>
                        <span className="space_form"></span>
                        <button type="button" name="bt1" className="button_form" onClick={register_step1} disabled={isPending}>{ isPending ? "AGUARDE ..." : "AVANÇAR" }</button>
                    
                    </form>
                </div>
                </>
                )}


                { step === 1 && (
                <>
                <div className="ft_topico">Faça seu cadastro com pouquíssimas informações</div>
                <div className="ft_descricao">Cadastrando-se, você terá acesso a nossa plataforma onde poderá realizar todas as configurações necessárias para seu agente funcionar de forma personalizada.</div>
                <div className="space"></div>
                <div className="border_form register_border_form">
                    <form className="form">
                        <span className="step_form">
                            <span className="step_form_number">Passo 2/3</span>
                            <span className="step_form_description">&nbsp;. Validar Token</span>
                        </span>
                        <span className="space_form"></span>

                        <span className="title_form">Confirmação de email</span>
                        <span className="subtitle_form">Por medidas de segurança, enviamos um token para:</span>
                        <span className="register_token_email">{getValues("email")}</span>
                        <span className="subtitle_form">Veja o token no seu email e digite abaixo para que possamos validá-lo e prosseguir com o cadastro.</span>
                        <span className="space_form"></span>

                        <span ref={refErrorToken} className="register_error_form"></span>
                        <div className="register_token_box">
                            <div className="register_token">
                                <div className="register_token_group">
                                    <span className="register_token_item"><input type="text" className="register_token_input" {...register("tk1")} ref={ (el) => {tokenRef[0].current = el; register("tk1").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 1) } onClick={clearErrorToken}></input></span>
                                    <span className="register_token_item"><input type="text" className="register_token_input" {...register("tk2")} ref={ (el) => {tokenRef[1].current = el; register("tk2").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 2) } onKeyDown={ (e) => handleKeyDown(e, 0) } onClick={clearErrorToken}></input></span>
                                    <span className="register_token_item"><input type="text" className="register_token_input" {...register("tk3")} ref={ (el) => {tokenRef[2].current = el; register("tk3").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 3) } onKeyDown={ (e) => handleKeyDown(e, 1) } onClick={clearErrorToken}></input></span>
                                    <span className="register_token_item"><input type="text" className="register_token_input" {...register("tk4")} ref={ (el) => {tokenRef[3].current = el; register("tk4").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 4) } onKeyDown={ (e) => handleKeyDown(e, 2) } onClick={clearErrorToken}></input></span>
                                    <span className="register_token_item"><input type="text" className="register_token_input" {...register("tk5")} ref={ (el) => {tokenRef[4].current = el; register("tk5").ref(el);} } maxLength={1} onKeyDown={ (e) => handleKeyDown(e, 3) } onClick={clearErrorToken}></input></span>
                                </div>
                            </div>
                            <span className="register_cronometer">{ formatMinutes(counter) }</span>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        <span className="subtitle_form">Não recebeu seu token ou não deu tempo de digitar?</span>
                        <div className="register_send_token" onClick={send_token}>Clique aqui para enviar outro token</div>
                        <span className="space_form"></span>
                        <span ref={refErrorStep2} className="error_form"></span>
                        <span className="space_form"></span>

                        <div className="register_buttons_box">
                            <div className="register_buttons_box_back"><button type="button" name="bt2a" className="button2_form" onClick={back_step}>VOLTAR</button></div>
                            <div className="register_buttons_box_space"></div>
                            <div className="register_buttons_box_next"><button type="button" name="bt2b" className="button_form" onClick={register_step2}>VALIDAR TOKEN</button></div>
                        </div>
                        
                    </form>
                </div>
                </>
                )}


                { step === 2 && (
                <>
                <div className="ft_topico">Faça seu cadastro com pouquíssimas informações</div>
                <div className="ft_descricao">Cadastrando-se, você terá acesso a nossa plataforma onde poderá realizar todas as configurações necessárias para seu agente funcionar de forma personalizada.</div>
                <div className="space"></div>
                <div className="border_form register_border_form">
                    <form className="form" onSubmit={handleSubmit(cadastrar)}>
                        <span className="step_form">
                            <span className="step_form_number">Passo 3/3</span>
                            <span className="step_form_description">&nbsp;. Definição de senha</span>
                        </span>
                        <span className="space_form"></span>

                    <span className="title_form">Senha de acesso</span>
                    <span className="subtitle_form">Para finalizar, crie uma senha de acesso a nossa plataforma.</span>
                    <span className="space_form"></span>
                    
                    <span ref={refErrorSenha} className="error_form"></span>
                    <label for="inp" className="inp" ref={refLabelSenha}>
                    <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senha")} ref={(el) => {refSenha.current = el; register("senha").ref(el);}} onClick={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onChange={(e) => {if (error === "0") {setLevelPass(e.target.value);} else {clearError(refSenha, refLabelSenha, refErrorSenha, error, setError);}}}></input>
                    <span className="label">Sua Senha</span>
                    <span className="focus-bg"></span>
                    </label>
                    <span className="space_form"></span>

                    <span ref={refErrorConfSenha} className="error_form"></span>
                    <label for="inp" className="inp" ref={refLabelConfSenha}>
                    <input type="password" placeholder="&nbsp;" maxLength={12} {...register("confsenha")} ref={(el) => {refConfSenha.current = el; register("confsenha").ref(el);}} onClick={() => clearError(refConfSenha, refLabelConfSenha, refErrorConfSenha, error, setError)} onChange={() => clearError(refConfSenha, refLabelConfSenha, refErrorConfSenha, error, setError)}></input>
                    <span className="label">Confirme a sua Senha</span>
                    <span className="focus-bg"></span>
                    </label>
                    <span className="space_form"></span>

                    <span className="register_aviso_senha">Nível da Senha:&nbsp;<span className="register_nivel_senha">{levelPassword(levelPass)}</span></span>
                    
                    <span className="space_form"></span>
                    <span ref={refError} className="error_form"></span>
                    <span className="space_form"></span>
                
                    <button type="submit" name="bt3" className={ isPending ? "button_disabled_form" : "button_form"} disabled={isPending}>{ isPending ? "AGUARDE ..." : "CONCLUIR" }</button>
                    
                    </form>
                </div>
                </>
                )}

                    
                { step === 3 && (
                <>
                <div className="ft_topico">Cadastro concluído</div>
                <div className="ft_descricao">Parabéns {firstName(getValues("responsavel"))}, agora você já pode acessar a plataforma e criar seu agente.</div>
                <span className="space"></span>
                <img className="register_image" src={icon_success}></img>
                <span className="space"></span>
                <span className="register_success_02">Aproveite! monte seu agente e explore todo o potencial que a IA pode lhe oferecer nas tarefas do dia a dia</span>                
                <span className="space"></span>
                <span className="register_success_03">Você tem 7 dias gratuítos para testar seu agente</span>
                <span className="space"></span>
                <div className="register_button"><Link to="/login" className="button_form register_button">ACESSAR A PLATAFORMA</Link></div>
                </>
                )}

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>
            
            <Footer access={0}></Footer>

        </div>
    )
}